export default __webpack_public_path__ + "static/media/Number_check.4ed5de5c.svg";